import SingleModelInterface from '../../../types/singleModelInterface'
import isEmpty from 'lodash.isempty'

export const getTrackingModel = (
    singleCarFromState: SingleModelInterface,
    selectedFormModelFromState: SingleModelInterface
): SingleModelInterface | null => {
    if (!isEmpty(singleCarFromState)) {
        return singleCarFromState as SingleModelInterface
    }

    if (!isEmpty(selectedFormModelFromState)) {
        return selectedFormModelFromState as SingleModelInterface
    }

    return null
}
